<!--<template>
  <div>
    <b-row align-h="end" class="mb-3">
      <b-col cols="6">
        <b-input-group>
          <b-form-input
            @keyup.enter="query"
            v-model="form.keyword"
            type="search"
            placeholder="Search here..."
          />
          <b-input-group-append>
            <b-button-group>
              <b-button @click="query" variant="primary" class="my-2 my-sm-0">
                <i class="fa fa-search"></i>
              </b-button>
              <b-dropdown right variant="light" ref="dropdown">-->
                <!-- -->
                <!--<b-dd-form :inline="true" style="width: 400px;">
                  <b-form-row class="mb-2">
                    <b-col cols="6">
                      <b-form-group
                        :label="$l('tips_updateTimeBegin') || '报价日期'"
                      >
                        <el-date-picker
                          v-model="form.quotationDate"
                          type="date"
                          :placeholder="
                            $l('INDEX.tips_select_date' || '选择日期')
                          "
                          style="width:100%;"
                          size="small"
                          value-format="yyyy-MM-dd"
                        >
                        </el-date-picker>
                      </b-form-group>
                    </b-col>
                    <b-col cols="6">
                      <b-form-group
                        :label="$l('tips_updateTimeEnd') || '截止日期'"
                      >
                        <el-date-picker
                          v-model="form.quotationExpiryDate"
                          type="date"
                          :placeholder="
                            $l('INDEX.tips_select_date' || '选择日期')
                          "
                          style="width:100%;"
                          size="small"
                          value-format="yyyy-MM-dd"
                        >
                        </el-date-picker>
                      </b-form-group>
                    </b-col>
                  </b-form-row>
                  <b-form-row class="mb-2">
                    <b-col cols="12">
                      <b-form-group :label="$l('tips_customer') || '客户'">
                        <dict-select
                          clearable
                          filterable
                          style="width:100%;"
                          v-model="form.custCode"
                          url="/digitalCenter/common/dict/customer"
                        ></dict-select>
                      </b-form-group>
                    </b-col>
                  </b-form-row>
                  <b-form-row class="mb-2">
                    <b-col cols="12">
                      <b-form-group :label="$l('tips_status') || '状态'">
                        <b-form-checkbox-group
                          style="width:100%;"
                          id="checkbox-group-2"
                          v-model="form.quotationStatusList"
                        >
                          <b-form-checkbox value="Y">{{
                            $l('tips_quotedPrice') || '已报价'
                          }}</b-form-checkbox>
                          <b-form-checkbox value="N">{{
                            $l('tips_add') || '新增'
                          }}</b-form-checkbox>
                        </b-form-checkbox-group>
                      </b-form-group>
                    </b-col>
                  </b-form-row>
                  <b-form-row>
                    <b-col style="text-align:center;">
                      <b-button block variant="primary" @click="query">{{
                        $l('btn_search') || 'Search'
                      }}</b-button>
                      <b-button
                        block
                        variant="outline-primary"
                        @click="reset"
                        >{{ $l('btn_reset') || 'Reset' }}</b-button
                      >
                    </b-col>
                  </b-form-row>
                </b-dd-form>
              </b-dropdown>
            </b-button-group>
          </b-input-group-append>
        </b-input-group>
      </b-col>
    </b-row>
  </div>
</template>-->
<template>
  <div class="search-form">
    <b-row align-h="between">
      <b-col cols="5">
        <b-form onsubmit="return false">
          <b-input-group size="sm">
            <b-form-input
              v-model="form.searchKey"
              @keyup.enter="query"
              type="search"
              :placeholder="'Search here...'"
              size="sm"
            />
            <b-input-group-append>
              <b-button-group>
                <b-button-group slot="reference">
                  <b-button
                    variant="link"
                    size="sm"
                    class="search-dropdown-button"
                    squared
                    @click="openAdvqueryDialog"
                  >
                    {{ $l("INDEX.advanced_search") || "高级搜索" }}
                  </b-button>
                  <b-button variant="primary" size="sm" @click="query">
                    <i class="fa fa-search" />
                  </b-button>
                </b-button-group>
              </b-button-group>
            </b-input-group-append>
          </b-input-group>
        </b-form>
      </b-col>
    </b-row>

    <el-dialog
      :title="$l('INDEX.advanced_search') || '高级搜索'"
      :show-close="true"
      :visible.sync="advqueryDialogVisible"
      width="700px"
      :close-on-click-modal="false"
    >
      <el-form ref="form" :model="form" size="medium">
        <el-row :gutter="20">
          <el-col :span="12">
            <el-form-item :label="$l('table_head_quotationNo') || '报价单编号'">
              <el-input
                v-model="form.quotationNo"
                :placeholder="$l('INDEX.tips_input_placeholder') || '请输入'"
                clearable
                size="small"
              >
              </el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item :label="$l('table_head_customerName') || '客户名称'">
              <el-input
                v-model="form.custName"
                :placeholder="$l('INDEX.tips_input_placeholder') || '请输入'"
                clearable
                size="small"
              >
              </el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="20">
          <el-col :span="12">
            <el-form-item
              :label="$l('table_head_correspondingProjectName') || '项目名称'"
            >
              <el-input
                v-model="form.prjTitle"
                :placeholder="$l('INDEX.tips_input_placeholder') || '请输入'"
                clearable
                size="small"
              >
              </el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item :label="$l('INDEX.Status') || '状态'">
              <br />
              <el-checkbox-group v-model="form.quotationStatusList">
                <el-checkbox label="Y">{{
                  $l("tips_quotedPrice") || "已报价"
                }}</el-checkbox>
                <el-checkbox label="N">{{
                  $l("tips_add") || "新增"
                }}</el-checkbox>
              </el-checkbox-group>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row style="margin-top: 10px">
          <el-form-item :label="$l('table_head_quotationDate') || '报价日期'">
            <br/>
            <el-col :span="11">
              <el-date-picker
                v-model="form.quotationDateBegin"
                type="date"
                size="small"
                value-format="yyyy-MM-dd"
                :placeholder="$l('INDEX.tips_select_date') || '选择日期'"
                style="width: 100%"
              >
              </el-date-picker>
            </el-col>
            <el-col class="line" :span="2" style="text-align: center">-</el-col>
            <el-col :span="11"
              ><el-date-picker
                v-model="form.quotationDateEnd"
                type="date"
                size="small"
                value-format="yyyy-MM-dd"
                :placeholder="$l('INDEX.tips_select_date') || '选择日期'"
                style="width: 100%"
              >
              </el-date-picker>
            </el-col>
          </el-form-item>
        </el-row>
        <el-row style="margin-top: 10px">
          <el-form-item :label="$l('table_head_closingDate') || '截止日期'">
            <br/>
            <el-col :span="11">
              <el-date-picker
                v-model="form.quotationExpiryDateBegin"
                type="date"
                size="small"
                value-format="yyyy-MM-dd"
                :placeholder="$l('INDEX.tips_select_date') || '选择日期'"
                style="width: 100%"
              >
              </el-date-picker>
            </el-col>
            <el-col class="line" :span="2" style="text-align: center">-</el-col>
            <el-col :span="11"
              ><el-date-picker
                v-model="form.quotationExpiryDateEnd"
                type="date"
                size="small"
                value-format="yyyy-MM-dd"
                :placeholder="$l('INDEX.tips_select_date') || '选择日期'"
                style="width: 100%"
              >
              </el-date-picker>
            </el-col>
          </el-form-item>
        </el-row>
      </el-form>

      <span slot="footer" class="dialog-footer">
        <el-button size="small" @click="closeAdvqueryDialog">{{
          $l("INDEX.btn_cancel_query") || "取消查询"
        }}</el-button>
        <el-button size="small" type="warning" @click="reset">{{
          $l("INDEX.btn_reset_filter ") || "重置条件"
        }}</el-button>
        <el-button size="small" type="primary" @click="advquery">{{
          $l("INDEX.btn_data_retrieval") || "数据检索"
        }}</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
const initForm = {
  quotationStatusList: ["Y", "N"],
  keyword: "",
};

export default {
  data() {
    return {
      advqueryDialogVisible: false,
      form: {
        ...initForm,
      },
    };
  },
  methods: {
    query() {
      this.$emit("submit", this.form);
    },
    onReset() {
      this.form = {
        ...initForm,
      };
      this.$emit("reset");
      this.query();
    },
    // 高级查询
    advquery() {
      this.form.searchKey = "";
      this.query();
      this.closeAdvqueryDialog();
    },
    // 重置查询条件 - 高级查询
    reset() {
      this.form = { ...initForm };
    },
    // 打开高级查询
    openAdvqueryDialog() {
      this.advqueryDialogVisible = true;
    },
    // 关闭高级查询
    closeAdvqueryDialog() {
      this.advqueryDialogVisible = false;
    },
  },
  mounted() {
    this.onReset();
  },
  activated() {
    this.onReset();
  },
};
</script>
